import React, { Component } from 'react'
import {StripeProvider,Elements} from  "react-stripe-elements";
import BillingStrip from './billingstripe'
import {stripe_api_key} from "../../../../../config/fbConfig"
class Billing extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    // console.log(this.props)
    return (
      <StripeProvider 
      apiKey={stripe_api_key}
      >
        <Elements>
          <BillingStrip 
          saveToken={this.props.saveToken}
          plan={this.props.plan}
          paymentTokenID={this.props.paymentTokenID}
          history={this.props.history}
          profile={this.props.profile}
          signUpFlow={this.props.signUpFlow}
          getPaymentToken={this.props.getPaymentToken}
          />
        </Elements>
      </StripeProvider>
    )
  }
}

export default Billing